import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { HistoryErrorState } from 'src/app/components/HistoryErrorState';
import { selectHistoryError } from 'src/features/historyError';
import { getDetailDevicePosition } from 'src/features/deviceSlice';

import 'date-fns';
import VehicleRoadMapTable from 'src/app/components/tables/VehicleRoadMapTable';
import { STATUS_API } from 'src/app/constant/config';
import {
  Slider,
  Typography,
  Popover,
  Box, Card, Slide, withStyles, makeStyles
} from '@material-ui/core';
import axios from 'src/app/axiosInterceptor';
import { carSpeed } from './constance';
import ToolBarRoadMap from '../ToolBarRoadMap';
import { ButtonShowMenuTracking } from '../button/ButtonMenu';
import TableSetting from './TableSetting';
import { useTheme, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  noDataMessage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
    height: '100px',
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    border: '1px dashed #ccc',
    borderRadius: '4px'
  },
  valueLabel: {
    fontSize: '12px',
    padding: '2px 6px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '4px',
    top: -22
  },
  totalDistance: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#0C1132'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
}));

const PrettoSlider = withStyles(theme => ({
  root: {
    height: 4,
    width: 250,
    marginLeft: '1.5em',
    marginRight: '1.5em'
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#C62222',
    borderRadius: '50%',
    border: '1px solid white',
    '&:focus, &$active': {
      boxShadow: '0 0 0 8px rgba(198, 34, 34, 0.16)'
    },
    '&:hover': {
      backgroundColor: '#E57373',
      transform: 'scale(1.2)',
      boxShadow: '0 0 0 8px rgba(198, 34, 34, 0.16)'
    },
    marginTop: -6,
    marginLeft: -8
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 8px)',
    top: -22,
    fontSize: '12px',
    fontWeight: '500',
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    padding: 0,
    borderRadius: 0,
    whiteSpace: 'nowrap',
    '& *': {
      background: 'transparent',
      color: theme.palette.primary.main
    }
  },
  track: {
    height: 4,
    borderRadius: 4,
    backgroundColor: '#C62222'
  },
  rail: {
    height: 4,
    borderRadius: 4,
    backgroundColor: '#E0E0E0'
  }
}))(Slider);
const HEADER_HEIGHT = 110;
const useBottomSheetStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    width: '100%',
    maxWidth: '100vw',
    background: '#fff',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 -4px 16px rgba(0,0,0,.15)',
    transition: 'height .25s ease'
  },

  collapsed: { height: 24 },
  expanded: {
    height: HEADER_HEIGHT
  },
  handle: {
    height: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    alignItems: 'flex-end',
    cursor: 'pointer'
  },
  handleBar: { width: 40, height: 4, borderRadius: 2, background: '#ccc' },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 12px 36px'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '4px'
  },
  listWrapper: { flex: 1, overflowY: 'auto' }
}));
const CONTROL_COLLAPSED_HEIGHT = 110;
const useRouteControlStyles = makeStyles(() => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: '#fff',
    transition: 'max-height .25s ease',
  },
  expanded: {
    maxHeight: 500
  },
  collapsed: {
    maxHeight: CONTROL_COLLAPSED_HEIGHT
  },
  handle: {
    height: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  handleBar: {
    width: 40,
    height: 4,
    borderRadius: 2,
    background: '#ccc'
  }
}));

const MenuBoxRouting = ({
  getVehicle,
  handleRoadTrackingUpdate,
  startFollow,
  resetTracking,
  pauseTracking,
  stoppedPoint,
  follow,
  mode,
  setShowMenu,
  showMenu,
  snapped,
  isPaused,
  setSpeed,
  position,
  setPosition,
  sliderAction,
  rePlay
}) => {
  const classes = useStyles();
  const bottomClasses = useBottomSheetStyles();
  const statusGetPositions = useSelector(
    state => state.deviceSlice.statusGetPositions
  );
  const positionsError = useSelector(
    selectHistoryError('deviceSlice', 'getDetailDevicePosition')
  );
  const dispatch = useDispatch();
  const waiting =
    statusGetPositions !== STATUS_API.SUCCESS && statusGetPositions !== null;
  const [showButton, setShowButton] = useState(false);
  const [speedIcon, setSpeedIcon] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [value, setValue] = useState(0);
  const [isRouteEnded, setIsRouteEnded] = useState(false);
  const routeControlClasses = useRouteControlStyles();
  const [controlExpanded, setControlExpanded] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const canCollapse =
    isMobile && showButton && statusGetPositions === STATUS_API.SUCCESS;

  const [showColumns, setShowColumns] = useState({
    gpsSpeedCol: true,
    speedCol: true,
    engineStatusCol: true,
    latLngCol: true
  });

  const handleShowColumns = event => {
    setShowColumns({
      ...showColumns,
      [event.target.name]: event.target.checked
    });
  };

  const totalDistance =
    snapped && snapped.length > 0
      ? snapped[snapped.length - 1].distance || 0
      : 0;

  const GetVehiclePosition = data => {
    setShowButton(true);
    handleRoadTrackingUpdate(data);
    resetTracking();
    setValue(0);
    setPosition(snapped[0] || {});
    setIsRouteEnded(false);
  };

  const handleClickSetting = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChangeSpeed = () => {
    const arrSpeed = [1, 2, 4, 8];
    const index = arrSpeed.findIndex(s => s === speedIcon);
    if (index < arrSpeed.length - 1) {
      setSpeedIcon(arrSpeed[index + 1]);
      const speedItem = carSpeed.find(cs => cs.speed === arrSpeed[index + 1]);
      const speed = speedItem?.speed;
      setSpeed(speed);
    } else {
      const speedItem = carSpeed.find(cs => cs.speed === arrSpeed[0]);
      const speed = speedItem?.speed;
      setSpeedIcon(arrSpeed[0]);
      setSpeed(speed);
    }
  };

  const handleReplay = () => {
    setValue(0);
    setPosition(snapped[0] || {});
    sliderAction(0);
    setIsRouteEnded(false);
    startFollow();
    rePlay();
  };
  const handleExportExcel = async () => {
    const access_token = localStorage.getItem('access-token');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/excel`,
        { vehicles: snapped },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`
          },
          responseType: 'blob'
        }
      );

      const blob = new Blob([response.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'vehicles_route_data.xlsx');
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Lỗi khi tải file:', error);
    }
  };

  const findCurrentIndex = () => {
    if (!position || !snapped || snapped.length === 0) return 0;
    const index = snapped.findIndex(
      item => item?.created_at === position?.created_at
    );
    return index >= 0 ? index : 0;
  };

  useEffect(() => {
    const newIndex = findCurrentIndex();
    setValue(newIndex);
    if (newIndex === snapped.length - 1 && follow && !isPaused) {
      pauseTracking();
      setIsRouteEnded(true);
    }
  }, [position, snapped, follow, isPaused, pauseTracking]);

  useEffect(() => {
    if (canCollapse) {
      setControlExpanded(false);
    }
  }, [canCollapse]);

  const handleChange = (event, newValue) => {
 
  if (follow && !isPaused) {
    pauseTracking();
  }

  setValue(newValue);
  if (snapped[newValue]) {
    setPosition(snapped[newValue]);
  }
  setIsRouteEnded(false);
};

  const handleChangeCommitted = 
    (event, newValue) => {
      sliderAction(newValue);
    }
  const formatDistanceLabel = value => {
    if (value === 0) return '0 km';
    if (!snapped || !snapped[value]) return '0 km';

    let distance = snapped[value].distance;
    if (!distance) {
      let prevIndex = value - 1;
      while (prevIndex >= 0) {
        const prevDistance = snapped[prevIndex].distance;
        if(prevDistance) {
          distance = prevDistance;
          break;
        }
        prevIndex--;
      }
    }

    return distance ? `${distance.toFixed(2)} km` : '0 km';
  };

  const open = Boolean(anchorEl);
  const iconSetting = open ? 'iconSettingActive' : 'iconSetting';

  return (
    <Slide
      direction="right"
      in={showMenu}
      style={{
        width: isMobile ? '100vw' : '384px',
        borderRadius: '6px',
        borderTop:'1px solid rgba(0,0,0,0.08)',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        zIndex: isMobile ? 1200 : 450,
        maxHeight:'calc(100vh - 66px)'

      }}
    >
      <Card className="menu_map_route">
        <ButtonShowMenuTracking showMenu={showMenu} setShowMenu={setShowMenu} />
        <Box
          className={`${routeControlClasses.root} ${
            !isMobile || controlExpanded
              ? routeControlClasses.expanded
              : routeControlClasses.collapsed
          }`}
        >
          {(!isMobile || controlExpanded) && (
            <>
              <ButtonShowMenuTracking
                showMenu={showMenu}
                setShowMenu={setShowMenu}
              />

              <ToolBarRoadMap
                resetTracking={resetTracking}
                GetVehiclePosition={GetVehiclePosition}
              />
              <Box style={{ marginTop: '5px' }}></Box>
            </>
          )}

          {showButton && statusGetPositions === STATUS_API.SUCCESS && (
            <div className={classes.headerContainer}>
              <Typography className={classes.totalDistance}>
                Tổng số Km: {totalDistance.toFixed(2)} km
              </Typography>
              <div className={classes.iconContainer}>
                <span
                  className="list_tracking_action"
                  onClick={() => handleExportExcel(stoppedPoint)}
                >
                  <img alt="excel_icon" src="/static/iconSvg/iconExcel.svg" />
                </span>
                <span style={{ cursor: 'pointer' }}>
                  <img
                    src={`/static/iconSvg/${iconSetting}.svg`}
                    alt="setting"
                    aria-describedby="settings-table"
                    onClick={handleClickSetting}
                  />
                </span>
                <Popover
                  id="settings-table"
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <TableSetting
                    showColumns={showColumns}
                    handleShowColumns={handleShowColumns}
                    handleClose={handleClose}
                  />
                </Popover>
              </div>
            </div>
          )}
          {showButton && !waiting && (
            <Box
              style={{
                marginTop: '25px',
                display: 'flex',
                verticalAlign: 'middle',
                alignItems: 'center'
              }}
            >
              {isRouteEnded ? (
                <span style={{ cursor: 'pointer' }} onClick={handleReplay}>
                  <img alt="replay" src="/static/iconSvg/iconReplay.svg" />
                </span>
              ) : follow ? (
                <span style={{ cursor: 'pointer' }} onClick={pauseTracking}>
                  {isPaused ? (
                    <img alt="icon" src="/static/iconSvg/iconPlay.svg" />
                  ) : (
                    <img alt="icon" src="/static/iconSvg/iconPause.svg" />
                  )}
                </span>
              ) : (
                <span style={{ cursor: 'pointer' }} onClick={startFollow}>
                  <img alt="icon" src="/static/iconSvg/iconPlay.svg" />
                </span>
              )}

              <PrettoSlider
                valueLabelDisplay="on"
                valueLabelFormat={formatDistanceLabel}
                aria-label="pretto slider"
                max={snapped.length - 1}
                defaultValue={0}
                min={0}
                value={value}
                onChange={handleChange}
                onChangeCommitted={handleChangeCommitted}
              />

              <img
                alt="icon"
                src={`/static/iconSvg/icon${speedIcon}x.svg`}
                onClick={handleChangeSpeed}
                style={{ cursor: 'pointer' }}
              />
            </Box>
          )}
          {canCollapse && (
            <div
              className={routeControlClasses.handle}
              onClick={() => setControlExpanded(v => !v)}
            >
              <div className={routeControlClasses.handleBar} />
            </div>
          )}
        </Box>
        {statusGetPositions === STATUS_API.ERROR && positionsError && (
          <HistoryErrorState
            error={positionsError}
            onRetry={() => dispatch(getDetailDevicePosition(positionsError.arg))}
          />
        )}
        {!isMobile &&
          showButton &&
          !waiting &&
          (snapped && snapped.length > 0 ? (
            <VehicleRoadMapTable
              vehiclesData={snapped}
              getVehicle={(rowCurrent, rowNext) => {
                getVehicle(rowCurrent, rowNext);
                setIsRouteEnded(false);
              }}
              mode={mode}
              showColumns={showColumns}
              sliderAction={sliderAction}
              currentSliderTime={position?.created_at}
            />
          ) : (
            <Typography className={classes.noDataMessage}>
              Không có dữ liệu
            </Typography>
          ))}

        {isMobile && showButton && statusGetPositions === STATUS_API.SUCCESS && (
          <Box
            className={`${bottomClasses.root} ${
              expanded ? bottomClasses.expanded : bottomClasses.collapsed
            }`}
          >
            <div
              className={bottomClasses.handle}
              onClick={() => setExpanded(v => !v)}
            >
              <div className={bottomClasses.handleBar} />
            </div>

            <div className={bottomClasses.listWrapper}>
              {snapped && snapped.length > 0 ? (
                <VehicleRoadMapTable
                  vehiclesData={snapped}
                  getVehicle={(rowCurrent, rowNext) => {
                    getVehicle(rowCurrent, rowNext);
                    setIsRouteEnded(false);
                  }}
                  mode={mode}
                  showColumns={showColumns}
                  sliderAction={sliderAction}
                  currentSliderTime={position?.created_at}
                />
              ) : (
                <Typography className={classes.noDataMessage}>
                  Không có dữ liệu
                </Typography>
              )}
            </div>
          </Box>
        )}
      </Card>
    </Slide>
  );
};

export default React.memo(MenuBoxRouting);
